import { gql } from '@apollo/client';

export * from './companyActiveSolutions.query.generated';

export const COMPANY_ACTIVE_SOLUTIONS = gql`
  query companyActiveSolutions {
    activeSoftwareEscrows: softwareEscrows(status: active) {
      nodesCount
    }
    activeBackups: backups(status: active) {
      nodesCount
    }
    activeSaasEscrows: saasEscrows(status: active) {
      nodesCount
    }
    activeContinuityEscrows: continuityEscrows(status: active) {
      nodesCount
    }
  }
`;
